// 阿拉伯语
export default {
    header_menu: {
        home: "الرئيسية",
        about: "من نحن",
        product: "المنتجات",
        news: "الأخبار",
        news_content: "تفاصيل الخبر",
        download: "مركز التحميل",
        contact: "اتصل بنا",
    },
    read_more: "اقرأ أكثر",
    prev: "المقال السابق",
    next: "المقال التالي",
    quick_navigation: "التنقل السريع",
    phone: "الهاتف",
    whatsapp: "واتساب",
    email: "البريد الإلكتروني",
    address: "العنوان",
    your_name: "اسمك",
    your_email: "بريدك الإلكتروني",
    content: "المحتوى",
    please_input: "يرجى إدخال ",
    leave_message: "أرسل استفسارًا",
    leave_success: "تم إرسال الرسالة بنجاح",
    click_count: "عدد النقرات",
    create_time: "وقت الإنشاء",
    upload_time: "وقت الرفع",
    //下载（动作）
    download: "تحميل",
    resources: "الموارد",
    products_type1: "فئات المنتجات",
    products_type2: "الفئات الفرعية",
    products_type3: "الفئات الفرعية",
    products_list: "قائمة المنتجات",
    products_detail: "تفاصيل المنتج",
    products_video: "فيديو المنتج",
    send_message: "أرسل استفسارًا",
    products_content: "محتوى المنتج",
    categories: "الفئات",
    send_email: "إرسال بريد إلكتروني",
    call_time: "ساعات الخدمة",
    our_location: "موقعنا",
    leave_message_to_us: "أرسل لنا استفسارًا",
    left_category: "الفئات",
    type_two: "الفئات الفرعية",
    type_three: "الفئات الفرعية",
    video_not_support: "متصفحك لا يدعم علامة الفيديو.",
    about_us: "من نحن",
    no_data: "لا توجد بيانات",
    home_about_subtitle: "مورد موثوق للأخشاب والخشب الرقائقي الفاخر للمشترين حول العالم",
    home_products_title: "منتجاتنا",
    home_products_subtitle: "استكشف فئات منتجاتنا الأساسية",
    view_all: "عرض الكل",
    home_stat_countries: "الدول التي نخدمها",
    home_stat_capacity: "الإنتاج السنوي (م³)",
    home_stat_years: "سنوات الخبرة",
    home_stat_clients: "العملاء حول العالم",
    footer_follow: "تابعنا على WeChat",
    footer_wechat: "WeChat",
    footer_copyright: "Debai Wood. جميع الحقوق محفوظة.",
    home_visual_year: "منذ 2009",
    home_visual_quote: "شريك موثوق للأخشاب والخشب الرقائقي للمشترين في أكثر من 60 دولة.",
    home_visual_tag: "FSC · ISO 9001 · CE معتمد",
    cta_title: "تبحث عن مورد موثوق للأخشاب والخشب الرقائقي؟",
    cta_sub: "احصل على عرض سعر تنافسي وتوصيل عالمي لطلبات الأخشاب بالجملة.",
    get_a_quote: "احصل على عرض سعر",
    home_banner_title: "أخشاب وخشب رقائقي فاخر للعالم",
    home_banner_sub: "مورد عالمي موثوق يخدم أكثر من 60 دولة بجودة معتمدة من FSC وISO 9001 وCE.",
    topbar_slogan: "أخشاب وخشب رقائقي فاخر — موثوق به لدى المشترين حول العالم",
    contact_hero_tag: "تواصل معنا",
    page_title: {
        home: "Debai Wood | مصنع ومورد عالمي للأخشاب والخشب الرقائقي",
        about: "من نحن | Debai Wood",
        products: "المنتجات | Debai Wood",
        news: "الأخبار | Debai Wood",
        download: "مركز التنزيلات | Debai Wood",
        contact: "تواصل معنا | Debai Wood",
        not_found: "الصفحة غير موجودة",
        back_home: "العودة إلى الرئيسية",
    },
    page_desc: {
        home: "Debai Wood هي شركة رائدة في تصنيع وتوريد الأخشاب والخشب الرقائقي على مستوى العالم، تخدم أكثر من 60 دولة بمنتجات حاصلة على شهادات FSC وISO 9001 وCE وتوصيل عالمي.",
        about: "تعرّف على Debai Wood — شركة موثوقة لتصنيع الأخشاب والخشب الرقائقي بخبرة تزيد على 15 عاماً وعملاء حول العالم وأنظمة جودة معتمدة.",
        products: "استكشف مجموعة Debai Wood الكاملة من الأخشاب والخشب الرقائقي: خشب رقائقي مغلف، OSB، MDF، أخشاب منشورة وحلول مخصصة للمشترين حول العالم.",
        news: "أحدث الأخبار والمعارض ورؤى القطاع من Debai Wood — شريكك الموثوق في الأخشاب والخشب الرقائقي.",
        download: "حمّل كتالوجات منتجات Debai Wood وشهادات الاعتماد (FSC وISO 9001 وCE) والبيانات الفنية للأخشاب والخشب الرقائقي.",
        contact: "تواصل مع Debai Wood للحصول على عروض أسعار تنافسية لطلبات الجملة من الأخشاب والخشب الرقائقي. توصيل عالمي ودعم مخصص لقطاع B2B.",
    },
}
